// import { Env } from '@loca/mfe-utils'
import { getEnv } from '@nio-wad/hooks'
import { getChannel, getClient } from '@/pages/chargermap/utils/getParams'

export const getPath = () => {
  return (process.config as { [key: string]: any })['url'][getEnv()]
}

export const getAppGatewayPath = () => {
  return (process.config as { [key: string]: any })['appGatewayPath'][getEnv()]
}

export const getCommonParams = (params_client?: string) => {
  const channelStr = getChannel()
  const client = params_client || window.client || getClient()
  window.client = client
  return {
    app_id: '100119',
    app_ver: '5.2.0',
    channel: channelStr,
    client: client,
    brand: (process.config as { [key: string]: any }).brand,
  }
}
